import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';
import { SIGN_UP_FORM_FIELD, SIGN_UP_FORM_FIELD_NAME } from './sign-up-form';
import {
  CHANGE_PASSWORD_FORM_FIELDS,
  CHANGE_PASSWORD_FORM_FIELDS_NAMES
} from '../profile-settings/account-security/change-password-form';
import { t } from 'i18next';
import { IConfirmInputs } from '../confirmAccount/confirm-account-form';

export const SIGN_UP_INPUTS = (): IFormInputProps[] => [
  {
    key: SIGN_UP_FORM_FIELD.FIRST_NAME,
    fieldName: SIGN_UP_FORM_FIELD.FIRST_NAME,
    placeholder: SIGN_UP_FORM_FIELD_NAME.FIRST_NAME,
    label: SIGN_UP_FORM_FIELD_NAME.FIRST_NAME,
    inputType: InputType.Text,
    additionalClasses: 'col-sx-6 col-md-6',
    required: true,
    // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
    autoComplete: 'given-name'
  },
  {
    key: SIGN_UP_FORM_FIELD.LAST_NAME,
    fieldName: SIGN_UP_FORM_FIELD.LAST_NAME,
    placeholder: SIGN_UP_FORM_FIELD_NAME.LAST_NAME,
    label: SIGN_UP_FORM_FIELD_NAME.LAST_NAME,
    inputType: InputType.Text,
    additionalClasses: 'col-sx-6 col-md-6',
    required: true,
    autoComplete: 'family-name'
  },
  {
    key: SIGN_UP_FORM_FIELD.EMAIL,
    fieldName: SIGN_UP_FORM_FIELD.EMAIL,
    placeholder: SIGN_UP_FORM_FIELD_NAME.EMAIL,
    label: SIGN_UP_FORM_FIELD_NAME.EMAIL,
    inputType: InputType.Text,
    additionalClasses: 'col-sx-6 col-md-6',
    required: true,
    autoComplete: 'email'
  },
  {
    key: SIGN_UP_FORM_FIELD.PHONE,
    fieldName: SIGN_UP_FORM_FIELD.PHONE,
    placeholder: SIGN_UP_FORM_FIELD_NAME.PHONE,
    label: SIGN_UP_FORM_FIELD_NAME.PHONE,
    inputType: InputType.Phone,
    defaultCountry: 'US',
    additionalClasses: 'col-sx-6 col-md-6',
    required: true,
    autoComplete: 'tel'
  },
  {
    key: SIGN_UP_FORM_FIELD.COMPANY_NAME,
    fieldName: SIGN_UP_FORM_FIELD.COMPANY_NAME,
    placeholder: SIGN_UP_FORM_FIELD_NAME.COMPANY_NAME,
    label: SIGN_UP_FORM_FIELD_NAME.COMPANY_NAME,
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-12',
    required: true,
    autoComplete: 'organization'
  },
  {
    key: SIGN_UP_FORM_FIELD.WEBSITE,
    fieldName: SIGN_UP_FORM_FIELD.WEBSITE,
    placeholder: SIGN_UP_FORM_FIELD_NAME.WEBSITE,
    label: SIGN_UP_FORM_FIELD_NAME.WEBSITE,
    inputType: InputType.Website,
    additionalClasses: 'col-sx-12 col-md-12',
    required: true,
    autoComplete: 'url'
  },
];


export const STRIPE_SIGN_UP_INPUTS = ({ showPassword, setShowPassword, showConfirmPassword, setShowConfirmPassword }): IConfirmInputs[] => [
  {
    key: CHANGE_PASSWORD_FORM_FIELDS.NEW_PASSWORD,
    fieldName: CHANGE_PASSWORD_FORM_FIELDS.NEW_PASSWORD,
    label: CHANGE_PASSWORD_FORM_FIELDS_NAMES.NEW_PASSWORD,
    placeholder: t(CHANGE_PASSWORD_FORM_FIELDS_NAMES.NEW_PASSWORD),
    showPassword: showPassword,
    setShowPassword: setShowPassword,
    additionalClass: 'password-container position-relative col-sx-12 col-md-12',
    isPasswordShown: true,
    isPasswordStrengthShown: true,
    // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
    autoComplete: 'new-password'
  },
  {
    key: CHANGE_PASSWORD_FORM_FIELDS.CONFIRM_PASSWORD,
    fieldName: CHANGE_PASSWORD_FORM_FIELDS.CONFIRM_PASSWORD,
    label: CHANGE_PASSWORD_FORM_FIELDS_NAMES.CONFIRM_PASSWORD,
    placeholder: t(CHANGE_PASSWORD_FORM_FIELDS_NAMES.CONFIRM_PASSWORD),
    showPassword: showConfirmPassword,
    setShowPassword: setShowConfirmPassword,
    additionalClass: 'password-container position-relative col-sx-12 col-md-12',
    isPasswordShown: true,
    autoComplete: 'new-password'
  }
];
